export function getSpotifyShowUrl(showUri?: string) {
  if (!showUri) return ''
  const showId = showUri.split(':')[2]
  return `https://open.spotify.com/show/${showId}`
}
